import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { Button, ButtonType } from '../atoms';
export const GoalMatchingAssessmentFormFooter = ({ isKindWeightGoal, isKindInterestingLesson, isDisabled, onClickNext, onClickCopyCurrentWeight, }) => {
    return (React.createElement("div", { className: css(styles.container) },
        isKindWeightGoal && (React.createElement(Button, { className: css(styles.nextButton, styles.nextHalfButton), onClick: onClickCopyCurrentWeight, buttonType: ButtonType.secondary, isRadius: true }, "\u73FE\u72B6\u7DAD\u6301")),
        React.createElement(Button, { className: css(styles.nextButton, isKindWeightGoal && styles.nextHalfButton), onClick: onClickNext, buttonType: isDisabled ? ButtonType.transparentPrimary : ButtonType.primary, disabled: isDisabled, isRadius: true }, isKindInterestingLesson && isDisabled ? '3つ以上選ぶと次へ進めます' : '次へ')));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.White,
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        gap: 16,
        bottom: 0,
        left: 0,
        width: '100%',
        padding: 16,
        [MediaBreakPointUp.MD]: {
            paddingBottom: 30,
        },
    },
    nextButton: {
        width: '100%',
        height: 48,
        padding: 0,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
        [MediaBreakPointUp.MD]: {
            width: 343,
        },
    },
    nextHalfButton: {
        [MediaBreakPointUp.MD]: {
            width: 163,
        },
    },
});
